import { render, staticRenderFns } from "./QualtListDetail.vue?vue&type=template&id=25c86d3b"
import script from "./QualtListDetail.vue?vue&type=script&lang=js"
export * from "./QualtListDetail.vue?vue&type=script&lang=js"
import style0 from "./QualtListDetail.vue?vue&type=style&index=0&id=25c86d3b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports